import React, { useEffect, useState } from 'react';
import _Module from '../controllers/module';
import Lobby from './modrp/Lobby';
import Logo from './modrp/Logo';
import { readCookie } from '../controllers/cookies';
import MyLobby from './modrp/MyLobby';
import { locales } from '../translations/locales';
import GameHomePage from './modrp/GameHomePage';
import Configuration from './modrp/Configuration';
import Shop from './modrp/Shop';
import Assignments from './modrp/Assignments';
import Sga from './modrp/sga/Sga';
import Sgo from './modrp/sgo/Sgo';
import BipShortcut from './modrp/bip/bipShortcut';
import ModalAlert from './modals/ModalAlerts';


export let ModuleRP = null;

const ModRP = (props) => {
    const { locale, theme } = props;
    const [update, setUpdate] = useState(0);
    const [data, setData] = useState([]);
    const [isConnected, setIsConnected] = useState(false);
    const [alert, setAlert] = useState([]);

    if (!ModuleRP) {
        ModuleRP = new _Module();
    }

    useEffect(() => {
        if (!isConnected) {
            ModuleRP.init(setUpdate, setData, setAlert);
        }
        return () => {
            setIsConnected(true);
        };
    }, [update, data, isConnected, alert]);

    return (
        <div className='container-fluid p-0 m-0 d-flex justify-content-center modrp' id='modrp'>
            {

                !readCookie('_asid') ?
                    <Logo text={locales[locale].session.needLogIn} button={true} locale={locale} theme={theme} /> :
                    ModuleRP.page === 'Logo' ?
                        <Logo text={ModuleRP.lobbyText} load={ModuleRP.refreshList} locale={locale} theme={theme} /> :
                        ModuleRP.page === 'MyLobby' ?
                            <MyLobby data={data} ModuleRP={ModuleRP} locale={locale} theme={theme} /> :
                            ModuleRP.page === 'Lobby' ?
                                <Lobby data={data} ModuleRP={ModuleRP} locale={locale} theme={theme} /> :
                                ModuleRP.page === 'GameHomePage' ?
                                    <GameHomePage data={data} ModuleRP={ModuleRP} locale={locale} theme={theme} /> :
                                    ModuleRP.page === 'Sga' ?
                                        <Sga data={data} ModuleRP={ModuleRP} locale={locale} theme={theme} /> :
                                        ModuleRP.page === 'Sgo' ?
                                            <Sgo data={data} ModuleRP={ModuleRP} locale={locale} theme={theme} /> :
                                            ModuleRP.page === 'Assignments' ?
                                                <Assignments data={data} ModuleRP={ModuleRP} locale={locale} theme={theme} /> :
                                                ModuleRP.page === 'Configuration' ?
                                                    <Configuration data={data} ModuleRP={ModuleRP} locale={locale} theme={theme} /> :
                                                    ModuleRP.page === 'Shop' ?
                                                        <Shop data={data} ModuleRP={ModuleRP} locale={locale} theme={theme} /> :
                                                        <Logo text={'En attente de données ... Connexion au serveur ... Patientez ...'} theme={theme} />
            }
            {
                isConnected && ModuleRP.page !== 'MyLobby' && ModuleRP.page !== 'Lobby' ?
                    <BipShortcut ModuleRP={ModuleRP} locale={locale} theme={theme} /> : null
            }
            {
                isConnected && alert ?
                    <ModalAlert locale={locale} theme={theme} alerts={alert} /> : null
            }
        </div>
    );
};

export default ModRP;
